// extracted by mini-css-extract-plugin
module.exports = {"linkcard":"styles__linkcard__iN0T6","linkcontainer":"styles__linkcontainer__dr7-T"};